var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "BoxWrap",
        { attrs: { title: _vm.$t("serviceProvider.BoxWrap.manage") } },
        [
          _c(
            "div",
            { staticClass: "action-container" },
            [
              _c(
                "el-form",
                {
                  attrs: { size: "small", inline: "", "label-position": "top" },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "serviceProvider.input.serviceProviderCode"
                        ),
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "serviceProvider.input.inputHolder"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchVal.serviceProviderCode,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchVal, "serviceProviderCode", $$v)
                          },
                          expression: "searchVal.serviceProviderCode",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "serviceProvider.input.serviceProviderName"
                        ),
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "serviceProvider.input.inputHolder"
                          ),
                          clearable: "",
                        },
                        model: {
                          value: _vm.searchVal.serviceProviderName,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchVal, "serviceProviderName", $$v)
                          },
                          expression: "searchVal.serviceProviderName",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: _vm.$t(
                          "serviceProvider.input.serviceProviderNameRegion"
                        ),
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t(
                              "serviceProvider.input.optionPlaceholder"
                            ),
                            clearable: "",
                          },
                          model: {
                            value: _vm.searchVal.serviceProviderNameRegion,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.searchVal,
                                "serviceProviderNameRegion",
                                $$v
                              )
                            },
                            expression: "searchVal.serviceProviderNameRegion",
                          },
                        },
                        _vm._l(
                          _vm.serviceProviderStatus,
                          function (item, index) {
                            return _c("el-option", {
                              key: index,
                              attrs: { label: item.name, value: item.code },
                            })
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "header-bottom-right" }, [
            _c(
              "div",
              { staticClass: "header-bottom-right-btn" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "small", icon: "el-icon-refresh" },
                    on: { click: _vm.resetData },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.reset")))]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    staticClass: "t-search-btn",
                    attrs: { size: "small", icon: "el-icon-search" },
                    on: { click: _vm.searchData },
                  },
                  [_vm._v(_vm._s(_vm.$t("common.search")))]
                ),
              ],
              1
            ),
          ]),
        ]
      ),
      _vm._v(" "),
      _c(
        "BoxWrap",
        {
          staticClass: "main-table-container",
          attrs: { title: _vm.$t("serviceProvider.BoxWrap.list") },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                "highlight-current-row": "",
                "tooltip-effect": "dark",
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "serviceProviderID",
                  label: _vm.$t("serviceProvider.table.serviceProviderID"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceProviderName",
                  label: _vm.$t("serviceProvider.table.serviceProviderName"),
                  width: "240",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "province",
                  label: _vm.$t("serviceProvider.table.province"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "city",
                  label: _vm.$t("serviceProvider.table.city"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "district",
                  label: _vm.$t("serviceProvider.table.district"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceProviderAddress",
                  label: _vm.$t("serviceProvider.table.serviceProviderAddress"),
                  width: "180",
                  align: "left",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("serviceProvider.table.action"),
                  fixed: "right",
                  align: "left",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-dropdown",
                          { attrs: { trigger: "click", size: "medium" } },
                          [
                            _c("el-button", {
                              staticClass: "t-square-btn t-more-btn",
                              attrs: {
                                type: "danger",
                                size: "mini",
                                icon: "el-icon-more",
                                circle: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "el-dropdown-menu",
                              { attrs: { slot: "dropdown" }, slot: "dropdown" },
                              [
                                _c(
                                  "el-dropdown-item",
                                  {
                                    directives: [
                                      {
                                        name: "FPermission",
                                        rawName: "v-FPermission",
                                        value: {
                                          pageName: _vm.pageName,
                                          list: ["ADD_EDIT"],
                                        },
                                        expression:
                                          "{pageName, list: ['ADD_EDIT']}",
                                      },
                                    ],
                                    staticClass: "t-square-btn t-green-btn",
                                    attrs: {
                                      type: "primary",
                                      size: "mini",
                                      circle: "",
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.edit(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(_vm.$t("common.edit")))]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total>0",
              },
            ],
            attrs: { total: _vm.total, page: _vm.currPage, limit: _vm.limit },
            on: {
              "update:page": function ($event) {
                _vm.currPage = $event
              },
              "update:limit": function ($event) {
                _vm.limit = $event
              },
              pagination: _vm.fetchData,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }